import { render, staticRenderFns } from "./EnforcementLaw.vue?vue&type=template&id=3f72119f&"
import script from "./EnforcementLaw.vue?vue&type=script&lang=js&"
export * from "./EnforcementLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports